import { type SelectionReducerPolicies } from '@databases/selections';
import { type DatabaseAdapter } from '@databases/selections-api-types';

export type CreateDatabaseSelectionReducerPoliciesDeps = {
  canEditContent: () => boolean;
  adapter: DatabaseAdapter;
};

/**
 * Creates the reducer policies for the selections machine.
 */
export function createDatabaseSelectionReducerPolicies(
  deps: CreateDatabaseSelectionReducerPoliciesDeps
): SelectionReducerPolicies {
  return {
    canRequestCellEdit: (cell, editingContext) => {
      if (!deps.canEditContent()) {
        return false;
      }

      const entryId = deps.adapter.getVisibleEntryIdAt(cell.row.index);
      const fieldId =
        editingContext === 'panel'
          ? deps.adapter.getAllFieldIds()[cell.col.index]
          : deps.adapter.getVisibleFieldIdAt(cell.col.index);

      if (!entryId || !fieldId) {
        return false;
      }

      return deps.adapter.canRequestValueEdit(fieldId, entryId);
    },

    canClearCells: (_selections) => deps.canEditContent(),
  };
}
